import {
  PapiDaUserProfileModuleExhibitionistConfig,
  PapiPremiumFolderData,
} from '@wix/da-papi-types';

export interface Modules {
  [moduleId: number]: any;
}

export enum ModulePriv {
  EDIT = 'edit',
  DELETE = 'delete',
}

// Please keep these sorted by enum const
export enum ModuleType {
  ABOUT = 'about',
  ACTIVE_MEMBERS = 'active_members',
  ADMINS = 'members',
  BADGES_ACTIVITY = 'badges_activity',
  BADGES_SPOTLIGHT = 'badges_spotlight',
  COMMENTS = 'comments',
  COMMISSIONS = 'commissions',
  COVER_DEVIATION = 'cover_deviation',
  CUSTOM = 'papi_custombox',
  DAS = 'digital_assets',
  DEVIOUSNESS = 'deviousness',
  DONATIONS = 'donations',
  DRAFTS = 'drafts',
  EXHIBITIONIST = 'exhibitionist',
  FEATURED_DEVIATION = 'featured_deviation',
  FEATURED_DEVIATIONS = 'featured',
  FEATURED_JOURNALS = 'featured_journals',
  FEATURED_POST = 'featured_post',
  FEATURED_POSTS = 'featured_posts',
  FEED = 'feed',
  FEED_PINNED_DEVIATION = 'feed_pinned_deviation',
  FOLDERS = 'folders',
  FOLDER_DEVIATIONS = 'folder_deviations',
  GROUPS_ADMIN = 'group_list_admins',
  GROUPS_MEMBER = 'group_list_members',
  JOURNALS = 'journals',
  LATEST_DEVIATIONS = 'latest_deviation',
  LLAMA_FARM = 'llama_farm',
  MEGABOX = 'megabox',
  MY_COMMENTS = 'my_comments',
  NEWEST_DEVIATIONS = 'newest',
  POLLS = 'polls',
  POSTS_FEED = 'posts_feed',
  PREMIUM_CONTENT = 'premium_content',
  PREMIUM_FOLDERS = 'premium_folders',
  PRINTS = 'prints',
  STATS = 'userstats',
  STATUSES = 'statuses',
  SUBSCRIPTION_CENTER = 'subscription_center',
  SUBSCRIPTION_TIPS = 'subscription_tips',
  TIERS = 'tiers',
  TIER_CONTENT = 'tier_content',
  WATCHERS = 'watchers',
  WATCHING = 'watching',
}

export type ExhibitionistModuleConfig =
  PapiDaUserProfileModuleExhibitionistConfig;
export type ExhibitionistModuleOptions = ExhibitionistModuleConfig['options'];
export type ExhibitionistModuleGalleryListItem = Unpacked<
  ExhibitionistModuleOptions['galleryList']
>;
export type ExhibitionistModuleCollectionListItem = Unpacked<
  ExhibitionistModuleOptions['collectionList']
>;
export type ExhibitionistModuleSourceTypeOptions =
  ExhibitionistModuleOptions['sourceTypes'];
export type ExhibitionistModuleFolderList = Pick<
  ExhibitionistModuleOptions,
  'galleryList' | 'collectionList'
>;
export type ExhibitionistPremiumFolderData = NonNullable<PapiPremiumFolderData>;

export enum ExhibitionistViewMode {
  TORPEDO = 'torpedo',
  SLIDESHOW = 'slideshow',
}

export enum ExhibitionistSlideFitMode {
  FIT = 'fit',
  COVER = 'cover',
}
